import {
  PageDto,
  TableConfigDto,
  TableDto,
  WidgetDto,
} from '@asset-metrix/portal-gateway-client-js';

type TableWidget = WidgetDto & {
  entity: TableDto;
};

function isTableWidget(widget: WidgetDto): widget is TableWidget {
  return widget.entity.type === 'table';
}

export function findTableConfigForEntity(
  contents: PageDto['contents'],
  entityId: string
): TableConfigDto | null {
  const tableWidgets = getAllTableWidgets(contents);
  const tableWidget = tableWidgets.find((widget) => widget.id === entityId);
  return tableWidget?.entity.config ?? null;
}

export function getAllTableWidgets(
  contents: PageDto['contents']
): TableWidget[] {
  const tableConfigs: TableWidget[] = [];
  for (const content of contents) {
    if (content.type === 'widget' && isTableWidget(content)) {
      tableConfigs.push(content);
    } else if (
      content.type === 'singleColumnGroup' ||
      content.type === 'twoColumnGroup'
    ) {
      tableConfigs.push(...getAllTableWidgets(content.contents));
    } else if (content.type === 'tabGroup') {
      for (const tab of content.contents) {
        tableConfigs.push(...getAllTableWidgets(tab.contents));
      }
    }
  }
  return tableConfigs;
}
